export default __webpack_public_path__ + "static/media/CormorantGaramondLightItalic.d388e36b.woff2";